import { SUPPORTED_JOINABLE_SITES } from '../model/productType';
import measurePerformance, { PerformanceMetric } from '../util/measurePerformance';

import RestClient from './RestClient';

export interface UserResponse {
  account_id: string;
  email: string;
  locale?: string;
  name: string;
  picture: string;
}

export interface JoinableSite {
  cloudId: string;
  displayName: string;
  products: string[];
  relevance?: number;
  size?: number;
  url: string;
}

export interface JoinableSitesResponse {
  joinableSites: JoinableSite[];
}

export interface ProductContext {
  productKey: 'jira' | 'confluence';
  siteId: string;
}

class IdentityClient extends RestClient {
  getJoinableSites(): Promise<JoinableSitesResponse> {
    return measurePerformance(PerformanceMetric.JoinableSitesService, () =>
      this.postResource('/gateway/api/joinable-sites', { products: SUPPORTED_JOINABLE_SITES }),
    );
  }
  getUser({ retryMS }: { retryMS: number[] }): Promise<UserResponse> {
    return measurePerformance(PerformanceMetric.IdentityMeService, () => this.getResource('/gateway/api/me'), retryMS);
  }
}

export default new IdentityClient();
